<template>
    <v-card class="cardWrap">
        <CardTitle title="プラン一覧" />
        <template>
            <v-form ref="form" lazy-validation>
                <v-row no-gutters class="mx-3">
                    <v-col cols="3">
                        <v-select
                            class="mr-3 pt-4"
                            v-model="golfCode"
                            :items="golfSelect"
                            item-value="golf_code"
                            item-text="golf_name"
                            label="ゴルフ場名"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field
                            class="mr-3 pt-4"
                            v-model="planName"
                            label="プラン名"
                            single-line
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="auto">
                        <v-card class="mx-2 mb-3">
                            <v-card-subtitle class="pb-0 pt-2 px-2 search-title">公開区分</v-card-subtitle>
                            <v-card-text class="pb-0 px-1">
                                <v-row no-gutters>
                                    <v-checkbox
                                        class="mr-2 mt-0"
                                        v-for="(d, index) in displayMemberClass"
                                        :key="index"
                                        :label="d.code_name"
                                        :value="d.code"
                                        v-model="planMemberClass"
                                    />
                                    <v-col>
                                        <v-radio-group
                                            class="px-2 mt-0"
                                            v-model="searchFlag"
                                            row>
                                            <v-radio
                                                label="AND"
                                                value="1" />
                                            <v-radio
                                                label="OR"
                                                value="0" />
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="auto">
                        <v-card class="mr-3 mb-3">
                            <v-card-subtitle class="pb-0 pt-2 px-2 search-title">公開設定</v-card-subtitle>
                            <v-card-text class="pb-0 px-2">
                                <v-row no-gutters>
                                    <v-checkbox
                                        class="mr-3 mt-0"
                                        v-model="searchOpenFlag"
                                        label="公開"
                                        value="1"
                                        @change="setOpenFlag()"
                                    />
                                    <v-checkbox
                                        class="mr-0 mt-0"
                                        v-model="searchCloseFlag"
                                        label="非公開"
                                        value="1"
                                        @change="setOpenFlag()"
                                    />
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="3" class="searchBtn">
                        <v-btn
                            :disabled="btn[1].isActive"
                            color="primary"
                            class="ml-5"
                            @click="clickSearch"
                            large
                            >検索</v-btn
                        >
                    </v-col>
                </v-row>
            </v-form>
        </template>
        <v-divider></v-divider>
        <template>
            <v-row no-gutters>
                <v-col cols='1'>
                    <div class="select-year mt-3">{{ selectYear }}年</div>
                </v-col>
                <v-col cols='11'>
                    <v-row no-gutters>
                        <v-card
                            class="px-2 py-2 mx-1 my-2"
                            @click="prevYear()"
                        >
                            <div class="yearly-switch">前年</div>
                        </v-card>
                        <v-card
                            v-for="month in dispMonth"
                            :key="month.key"
                            class="px-2 py-2 mx-1 my-2"
                            :disabled="month.disabled"
                            v-model="selectYearMonth"
                            @click="changeMonth(month.month)"
                        >
                            <div :class="month.class">{{ month.dispMonth }}</div>
                        </v-card>
                        <v-card
                            class="px-2 py-2 mx-1 my-2"
                            @click="nextYear()"
                        >
                            <div class="yearly-switch">翌年</div>
                        </v-card>
                    </v-row>
                </v-col>
            </v-row>
        </template>
        <v-data-table
            :headers="headers"
            :items="desserts"
            hide-default-footer
            class="elevation-1"
        >
            <template v-slot:[`item.detail`]="{ item }">
                <v-btn
                    :disabled="btn[2].isActive"
                    color="green darken-4"
                    small
                    text
                    @click="PlanDetailChangeDialog(item)"
                    >詳細</v-btn
                >
            </template>
            <template v-slot:[`item.setting`]="{ item }">
                <v-btn
                    :disabled="
                        btn[3].isActive ||
                        item.plan_member_class === deleteStatus
                            ? true
                            : false
                    "
                    color="green darken-4"
                    small
                    text
                    @click="PlanCellSettingListDialog(item)"
                    >枠連携</v-btn
                >
            </template>
            <template v-slot:[`item.copy`]="{ item }">
                <v-btn
                    :disabled="
                        btn[4].isActive ||
                        item.plan_member_class === deleteStatus
                            ? true
                            : false
                    "
                    color="green darken-4"
                    small
                    text
                    @click="copyPlanInfo(item)"
                    >コピー</v-btn
                >
            </template>
        </v-data-table>
        <v-pagination
            class="my-2"
            v-model="page"
            :length="pageCount"
            :total-visible="7"
            @input="clickPagination"
        ></v-pagination>
        <v-spacer></v-spacer>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                :disabled="btn[6].isActive || desserts.length === 0"
                color="primary"
                @click="AllPlanCellListDialog()"
            >料金連携
            </v-btn>
            <v-btn
                :disabled="btn[5].isActive"
                color="primary"
                @click="PlanDetailAddDialog()"
                >追加</v-btn
            >
        </v-card-actions>
        <PlanDetail
            :dialog="planDialog"
            :golfSelectProps="golfSelect"
            @close="closeChild"
            ref="Detail"
        />
        <PlanCellReleaseSetting
            :dialog="planCellSettingDialog"
            :propsAdmin="passCellAdmin"
            :golfCourseCode="passCellGolfCourseToChild"
            :golfSelectProps="passCellGolfSelect"
            :propsPlanName="passCellPlanNameToChild"
            :propsPlanId="passCellPlanIDToChild"
            @close="closeCellChild"
            :propsYearMonth="passCellYearMonth"
        />
        <AllPlanCellsFeeSetting
            :dialog="allPlanFeeDialog"
            :propsAdmin="passFeeAdmin"
            :golfCourseProps="passFeeGolfCourseToChild"
            :golfSelectProps="passFeeGolfSelect"
            :propsFeePlan="passFeePlan"
            :propsYearMonth="passTo"
            @close="closeFeeChild"
            @loading="changeLoading"
            ref="child"
        />
    </v-card>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
// モーダル
import PlanDetail from './dialog/PlanDetail';
import PlanCellReleaseSetting from './dialog/PlanCellReleaseSetting';
import AllPlanCellsFeeSetting from './dialog/AllPlanCellsFeeSetting';
// graghql
import {
    GET_PLAN_LIST,
    GET_PLAN_ALL_LIST,
    REGIST_PLAN_MASTER,
    COPY_PLAN_MASTER
} from '@/constants/plan';

export default {
    components: {
        CardTitle,
        PlanDetail,
        PlanCellReleaseSetting,
        AllPlanCellsFeeSetting
    },
    data () {
        return {
            // データテーブルに渡す値
            desserts: [],
            // データテーブルの見出し要素
            headers: [
                { text: 'プランコード', value: 'plan_id', sortable: false },
                { text: 'プラン名', value: 'plan_name', sortable: false },
                {
                    text: '優先度',
                    value: 'display_priority',
                    align: 'left',
                    sortable: false
                },
                {
                    text: '',
                    align: 'center',
                    value: 'detail',
                    sortable: false,
                    width: '150'
                },
                {
                    text: '',
                    align: 'center',
                    value: 'setting',
                    sortable: false,
                    width: '150'
                },
                {
                    text: '',
                    align: 'center',
                    value: 'copy',
                    sortable: false,
                    width: '150'
                }
            ],
            // プランID 子に渡すデータ
            passCellPlanIDToChild: '',
            // プランネーム 子に渡すデータ
            passCellPlanNameToChild: '',
            // ゴルフ場コード 子に渡すデータ
            passCellGolfCourseToChild: '',
            passFeeGolfCourseToChild: '',
            // 選択年月 子に渡すデータ
            passCellYearMonth: '',
            // 子のダイアログの状態 trueにすると表示
            planDialog: false,
            // 子のダイアログの状態 trueにすると表示
            planCellSettingDialog: false,
            // 料金一括連携ダイアログの状態 trueにすると表示
            allPlanFeeDialog: false,
            // ゴルフグループ
            golfGroupCode: process.env.VUE_APP_GROUP_CODE,
            // チェックボックス
            displayMemberClass: [],
            // ゴルフ場セレクトボックス
            golfSelect: [],
            passFeeGolfSelect: [],
            // 検索キーワード
            golfCode: '',
            // 検索キーワード
            passGolfName: '',
            // 検索キーワード
            planName: '',
            // 検索キーワード
            planMemberClass: [],
            planAllFlag: '0',
            // 検索キーワード
            shareFlag: null,
            // 検索キーワード
            requestFlag: null,
            // 公開検索フラグ
            searchOpenFlag: null,
            // 非公開検索フラグ
            searchCloseFlag: null,
            page: 1,
            pageCount: 0,
            // offset
            beginRow: 0,
            // 一覧の最大表示値
            limitRows: 10,
            // ログインしている者の情報
            admin: {
                user_id: '',
                user_div: '',
                golf_code: ''
            },
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: false },
                { element_id: '001', element_name: '検索', isActive: false },
                { element_id: '002', element_name: '詳細', isActive: false },
                { element_id: '003', element_name: '枠設定', isActive: false },
                { element_id: '004', element_name: 'コピー', isActive: false },
                { element_id: '005', element_name: '追加', isActive: false },
                { element_id: '006', element_name: '料金連携', isActive: false }
            ],
            vue_id: 'SCR0024',
            deleteStatus: '9',
            openFlag: null,
            searchFlag: '0',
            // 月タブリスト
            dispMonth: [],
            // 月タブ表示数
            rangeMonth: 12,
            // 選択月
            selectMonth: '',
            // 選択年
            selectYear: '',
            // 選択年月
            selectYearMonth: '',
            passTo: {
                year: '',
                month: ''
            },
            passFeePlan: {},
            passFeeAdmin: {},
            passCellAdmin: {},
            passCellGolfSelect: {},
            passDetailPlanIDToChild: ''
        };
    },
    async created () {
        this.$store.commit('loading/setIsLoading', true);
        this.getDateList();
        this.initialize();
        this.$store.commit('loading/setIsLoading', false);
    },
    watch: {
        golfCode () {
            const currentGolfCourse = this.golfSelect.find(
                el => el.golf_code === this.golfCode
            );
            this.passGolfName = currentGolfCourse.golf_name;
        }
    },
    methods: {
        /** --------------------------------------------
        * 初期表示
        * --------------------------------------------- */
        initialize () {
            this.$apollo.query({
                query: GET_PLAN_ALL_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    plan_name: this.planName,
                    plan_member_class: this.planMemberClass,
                    share_flag: this.shareFlag,
                    request_flag: this.requestFlag,
                    open_flag: this.openFlag,
                    search_flag: this.searchFlag,
                    offset: this.beginRow,
                    limit: this.limitRows,
                    select_month_start: this.selectYearMonth,
                    vue_id: this.vue_id,
                    element_id: ''
                }
            })
                .then(res => {
                    // 公開区分取得
                    this.displayMemberClass = res.data.getPlanAllListFromAdmin.CodeList;

                    // 管理者権限情報取得
                    this.admin = res.data.getPlanAllListFromAdmin.GetLoginAdmin;

                    // ゴルフ場リスト取得
                    this.golfSelect = res.data.getPlanAllListFromAdmin.GetGolfCourseList;
                    this.golfCode = this.golfSelect[0].golf_code;
                    // プラン一覧取得
                    this.desserts = res.data.getPlanAllListFromAdmin.PlanList;
                    const count = res.data.getPlanAllListFromAdmin.count;
                    this.pageCount = Math.ceil(count / this.limitRows);

                    // 権限情報取得
                    let opeList = res.data.getPlanAllListFromAdmin.OperationAccessList;
                    for (let list of opeList) {
                        this.btn.forEach(el => {
                            if (list.element_id === el.element_id) {
                                if (list.element_control === 0) {
                                    el.isActive = true;
                                } else {
                                    el.isActive = false;
                                }
                            }
                        });
                    };
                });
        },
        /** --------------------------------------------
         * プラン一覧情報を取得
         * -------------------------------------------- */
        getPlanList () {
            this.$store.commit('loading/setIsOpacityLoading', true);
            this.$apollo
                .query({
                    query: GET_PLAN_LIST,
                    fetchPolicy: 'no-cache',
                    variables: {
                        golf_group_code: process.env.VUE_APP_GROUP_CODE,
                        golf_code: this.golfCode,
                        plan_name: this.planName,
                        plan_member_class: this.planMemberClass,
                        share_flag: this.shareFlag,
                        request_flag: this.requestFlag,
                        open_flag: this.openFlag,
                        search_flag: this.searchFlag,
                        offset: this.beginRow,
                        limit: this.limitRows,
                        select_month_start: this.selectYearMonth
                    }
                })
                .then(res => {
                    this.desserts = res.data.getPlanListFromAdmin.PlanList;
                    const count = res.data.getPlanListFromAdmin.count;
                    this.pageCount = Math.ceil(count / this.limitRows);
                    this.$store.commit('loading/setIsOpacityLoading', false);
                });
        },
        /** ----------------------------------------------
         * 登録処理
         * ---------------------------------------------- */
        registPlanMaster () {
            return this.$apollo
                .mutate({
                    mutation: REGIST_PLAN_MASTER,
                    variables: {
                        golf_group_code: process.env.VUE_APP_GROUP_CODE,
                        golf_code: this.golfCode
                    }
                })
                .then(res => {
                    const result = res.data.registPlanMaster.result;
                    this.passDetailPlanIDToChild = res.data.registPlanMaster.planId;
                    if (result === 1) {
                        return result;
                    } else {
                        throw new Error('エラーが発生しました。');
                    }
                })
                .catch(error => {
                    this.error = error;
                });
        },
        /** --------------------------------------------
         * プランをコピーする
         * -------------------------------------------- */
        copyPlanInfo (data) {
            let result = confirm('プラン情報をコピーします。');
            if (result) {
                this.$apollo
                    .mutate({
                        mutation: COPY_PLAN_MASTER,
                        variables: {
                            plan_id: data.plan_id
                        }
                    })
                    .then(res => {
                        return res.data.copyPlanMaster.result;
                    })
                    .finally(res => {
                        this.getPlanList();
                    });
            }
        },
        /** --------------------------------------------
         * ページネーション処理
         * -------------------------------------------- */
        clickPagination () {
            this.beginRow = this.page * this.limitRows - this.limitRows;
            this.getPlanList();
        },
        /** --------------------------------------------
         * 検索ボタン処理
         * -------------------------------------------- */
        clickSearch () {
            this.page = 1;
            this.beginRow = 0;
            this.getPlanList();
        },
        /** --------------------------------------------
         * プラン詳細画面を追加モードで開く
         * -------------------------------------------- */
        async PlanDetailAddDialog () {
            const result = await this.registPlanMaster();
            if (result === 1) {
                this.planDialog = true;
                this.$refs.Detail.ModalControl(
                    this.admin,
                    this.passDetailPlanIDToChild,
                    this.golfCode,
                    this.passGolfName,
                    true
                );
            }
        },
        /** --------------------------------------------
         * プラン詳細画面を変更モードで開く
         * -------------------------------------------- */
        PlanDetailChangeDialog (data) {
            this.planDialog = true;
            this.$refs.Detail.ModalControl(
                this.admin,
                data.plan_id,
                this.golfCode,
                this.passGolfName,
                false
            );
        },
        /** --------------------------------------------
         * 枠連携画面を開く
         * -------------------------------------------- */
        PlanCellSettingListDialog (data) {
            this.passCellAdmin = this.admin;
            this.passCellPlanIDToChild = data.plan_id;
            this.passCellGolfCourseToChild = this.golfCode;
            this.passCellPlanNameToChild = data.plan_name;
            this.planCellSettingDialog = true;
            this.passCellYearMonth = this.selectYearMonth;
            this.passCellGolfSelect = this.golfSelect;
        },
        /** --------------------------------------------
         * 料金一括連携画面を開く
         * -------------------------------------------- */
        AllPlanCellListDialog () {
            this.passFeeAdmin = this.admin;
            this.passFeeGolfCourseToChild = this.golfCode;
            let date = new Date(this.selectYearMonth);
            let passYear = date.getFullYear();
            let passMonth = date.getMonth() + 1;
            this.passTo.year = passYear;
            this.passTo.month = passMonth;
            this.allPlanFeeDialog = true;
            this.passFeeGolfSelect = this.golfSelect;
            this.passFeePlan = {
                golf_group_code: process.env.VUE_APP_GROUP_CODE,
                golf_code: this.golfCode,
                plan_name: this.planName,
                plan_member_class: this.planMemberClass,
                share_flag: this.shareFlag,
                request_flag: this.requestFlag,
                open_flag: this.openFlag,
                search_flag: this.searchFlag,
                select_month_start: this.selectYearMonth
            };
        },
        /** --------------------------------------------
         * プラン詳細ダイアログを閉じる
         * -------------------------------------------- */
        closeChild () {
            this.planDialog = false;
            this.getPlanList();
        },
        /** --------------------------------------------
         * 枠連携ダイアログを閉じる
         * -------------------------------------------- */
        closeCellChild () {
            this.passCellPlanNameToChild = '';
            this.planCellSettingDialog = false;
        },
        /** --------------------------------------------
         * 料金連携ダイアログを閉じる
         * -------------------------------------------- */
        closeFeeChild () {
            this.allPlanFeeDialog = false;
        },
        /** ---------------------
         * 月タブリスト取得
         * --------------------- */
        getDateList () {
            var targetDate = new Date();
            var year = targetDate.getFullYear();
            this.selectYear = year;
            var month = targetDate.getMonth() + 1;
            this.selectMonth = month;
            var keyMonth = String(year) + ('00' + month).slice(-2);
            this.dispMonth = [];
            // 現在年分のリスト取得
            for (var i = 0; i < this.rangeMonth; i++) {
                var yearlyMonth = {};
                var countYearlyMonth = i + 1;
                var yearlyKeyMonth = String(year) + ('00' + countYearlyMonth).slice(-2);
                yearlyMonth['key'] = yearlyKeyMonth;
                yearlyMonth['month'] = countYearlyMonth;
                yearlyMonth['dispMonth'] = countYearlyMonth + '月';
                yearlyMonth['select_month_start'] = year + '-' + ('00' + countYearlyMonth).slice(-2) + '-' + '01';
                this.dispMonth.push(yearlyMonth);
            }
            // 選択月設定
            for (var k = 0; k < this.dispMonth.length; k++) {
                if (keyMonth === this.dispMonth[k]['key']) {
                    this.dispMonth[k]['class'] = 'month-active';
                    this.dispMonth[k]['disabled'] = true;
                    this.selectYearMonth = this.dispMonth[k]['select_month_start'];
                } else {
                    this.dispMonth[k]['class'] = 'non-active';
                    this.dispMonth[k]['disabled'] = false;
                }
            }
        },
        /** ---------------------
         * 月タブ選択
         * --------------------- */
        changeMonth (month) {
            for (var k = 0; k < this.dispMonth.length; k++) {
                if (month === this.dispMonth[k]['month']) {
                    this.dispMonth[k]['class'] = 'month-active';
                    this.dispMonth[k]['disabled'] = true;
                    this.selectYearMonth = this.dispMonth[k]['select_month_start'];
                    this.selectMonth = this.dispMonth[k]['month'];
                } else {
                    this.dispMonth[k]['class'] = 'non-active';
                    this.dispMonth[k]['disabled'] = false;
                }
            }
            this.getPlanList();
        },
        /** -------------------
         * 前年プラン取得
         * -------------------- */
        prevYear () {
            var prevYear = --this.selectYear;
            this.dispMonth = [];
            for (var i = 0; i < this.rangeMonth; i++) {
                var prevMonth = {};
                var countPrevMonth = i + 1;
                var prevKeyMonth = String(prevYear) + ('00' + countPrevMonth).slice(-2);
                prevMonth['key'] = prevKeyMonth;
                prevMonth['month'] = countPrevMonth;
                prevMonth['dispMonth'] = countPrevMonth + '月';
                prevMonth['select_month_start'] = prevYear + '-' + ('00' + countPrevMonth).slice(-2) + '-' + '01';
                this.dispMonth.push(prevMonth);
            }
            this.changeMonth(this.selectMonth);
        },
        /** -------------------
         * 翌年プラン取得
         * ------------------- */
        nextYear () {
            var nextYear = ++this.selectYear;
            this.dispMonth = [];
            for (var i = 0; i < this.rangeMonth; i++) {
                var nextMonth = {};
                var countNextMonth = i + 1;
                var NextKeyMonth = String(nextYear) + ('00' + countNextMonth).slice(-2);
                nextMonth['key'] = NextKeyMonth;
                nextMonth['month'] = countNextMonth;
                nextMonth['dispMonth'] = countNextMonth + '月';
                nextMonth['select_month_start'] = nextYear + '-' + ('00' + countNextMonth).slice(-2) + '-' + '01';
                this.dispMonth.push(nextMonth);
            }
            this.changeMonth(this.selectMonth);
        },
        /** --------------------------------------------
         * 公開、非公開検索フラグ設定
         * -------------------------------------------- */
        setOpenFlag () {
            if ((this.searchOpenFlag === '1' && this.searchCloseFlag === '1') ||
                (this.searchOpenFlag === null && this.searchCloseFlag === null)) {
                // どちらも設定されているか、どちらも設定されていない場合は条件を外す
                this.openFlag = null;
            } else if (this.searchOpenFlag === '1' && this.searchCloseFlag === null) {
                this.openFlag = 1;
            } else if (this.searchOpenFlag === null && this.searchCloseFlag === '1') {
                this.openFlag = 0;
            }
        },
        changeLoading (flag) {
            this.$store.commit('loading/setIsLoading', flag);
        }
    }
};
</script>

<style>
.point_select {
    color: black;
    background: Transparent;
    text-decoration: underline;
}

.selectWidth {
    width: 180px;
}

.v-input--selection-controls {
    margin-top: 10px;
}

.searchBtn {
    margin: 0 0 0 auto;
}

.container {
    padding: 0 12px;
}

.v-input__slot {
    margin-bottom: 0px;
}

.search-title {
    font-size: 12px;
}

.v-messages {
    min-height: 4px;
    height: 4px;
}
.month-active {
    color: black;
    width: 40px;
    text-align: center;
}

.non-active, .yearly-switch {
    color: blue;
    text-decoration: underline;
    width: 40px;
    text-align: center;
}
.select-year {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
}
</style>
